export default {
      id: "icon--reindeer-usage",
      viewBox: "0 0 71 71",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--reindeer-usage",
      toString: function () {
        return this.url;
      }
    }